export default __webpack_public_path__ + "static/media/qr_code_2.3ef5e50d.png";